export const SHOP_URL = "https://officiaa.com/";
export const PHONE_1 = "+91 95450 15003";
export const PHONE_1_TEL = "tel:+919545015003";
export const PHONE_2 = "+91 95950 72115";
export const PHONE_2_TEL = "tel:+919595072115";
export const WHATSAPP_URL = "https://wa.me/919545015003";
export const EMAIL = "sevayog.services@gmail.com";
export const EMAIL_2 = "info@cleenvo.in";
export const ADDRESS = "Shop No 1, Dalvi Heights, Mundhwa, Pune - 411036";
export const MAP_EMBED =
  "https://www.google.com/maps?q=Dalvi%20Heights%2C%20Mundhwa%2C%20Pune%2C%20Maharashtra%20411036&output=embed";
export const MAP_LINK = "https://share.google/isQnDM0zdtK7emQSH";

export const NAV = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Cleenvo", href: "#cleenvo" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact Us", href: "#contact" },
];

export const PRODUCTS = [
  {
    id: "floor-cleaner-1l",
    name: "All in 1 Floor & Surface Cleaner",
    variant: "Floral — 1 Litre",
    price: 120,
    mrp: 225,
    img: "/assets/products/A1C.png",
    tag: "Bestseller",
  },
  {
    id: "liquid-detergent-1l",
    name: "Liquid Detergent",
    variant: "All Washing Machines — 1 Litre",
    price: 130,
    mrp: 275,
    img: "/assets/products/DL1.png",
  },
  {
    id: "toilet-cleaner-500",
    name: "Disinfectant Toilet Cleaner",
    variant: "Original — 500 ml",
    price: 99,
    mrp: 170,
    img: "/assets/products/TC1.png",
  },
  {
    id: "floor-cleaner-lemon-1l",
    name: "Surface & Floor Cleaner",
    variant: "Lemon — 1 Litre",
    price: 80,
    mrp: 90,
    img: "/assets/products/FC1.png",
  },
  {
    id: "dishwash-375",
    name: "Dishwash Liquid & Kitchen Gel",
    variant: "Lemon Fragrance — 375 ml",
    price: 60,
    mrp: 89,
    img: "/assets/products/DW1.png",
  },
  {
    id: "handwash-500",
    name: "Lemon Hand Wash",
    variant: "99.9% Germ Protection — 500 ml",
    price: 99,
    mrp: 149,
    img: "/assets/products/HW1.png",
  },
  {
    id: "floor-cleaner-5l",
    name: "All in 1 Floor & Surface Cleaner",
    variant: "Floral — 5 Litre Bulk Pack",
    price: 500,
    mrp: 900,
    img: "/assets/products/A1C5.jpg",
    tag: "Bulk Pack",
  },
  {
    id: "floor-cleaner-lemon-5l",
    name: "Surface & Floor Cleaner",
    variant: "Lemon — 5 Litre Bulk Pack",
    price: 350,
    mrp: 450,
    img: "/assets/products/FC5.jpg",
    tag: "Bulk Pack",
  },
];

export const SERVICES = [
  {
    id: "housekeeping",
    title: "Housekeeping Supply",
    desc: "Bulk cleaning chemicals, tools, disposables and consumables for offices, societies, hotels and hospitals — anchored by our own Cleenvo range.",
    points: ["Cleaning chemicals & liquids", "Tools, mops & disposables", "Monthly supply contracts"],
    img: "/assets/svc-housekeeping.jpg",
  },
  {
    id: "stationery",
    title: "Office Stationery",
    desc: "Everything a workplace runs on — paper, writing instruments, files, pantry and desk essentials, delivered on schedule.",
    points: ["Paper & printing supplies", "Desk & pantry essentials", "Customised reorder cycles"],
    img: "/assets/svc-stationery.jpg",
  },
  {
    id: "procurement",
    title: "Corporate Procurement",
    desc: "One vendor for all facility needs. Consolidated sourcing, GST invoicing, credit terms and a dedicated account manager for your business.",
    points: ["Single-vendor consolidation", "GST billing & credit terms", "Dedicated account manager"],
    img: "/assets/svc-corporate.jpg",
  },
];

export const REVIEWS = [
  {
    id: "priya",
    name: "Priya Sharma",
    role: "Admin Manager, Corporate Office — Mumbai",
    text: "We source all our office housekeeping from Sevayog. The Cleenvo glass and floor cleaners are excellent — no streaks, just sparkling surfaces. Deliveries are always on time.",
  },
  {
    id: "sanjay",
    name: "Sanjay Patel",
    role: "Retailer — Ahmedabad",
    text: "As a wholesale buyer, I appreciate Cleenvo's consistent quality and bulk pack options. My customers love the products, and the 5L packs move fast off my shelves.",
  },
  {
    id: "ramesh",
    name: "Ramesh Iyer",
    role: "Facility Head, IT Park — Pune",
    text: "Sevayog handles our entire facility supply — housekeeping to stationery — on a single invoice. Their All-in-1 Floor Cleaner keeps our premises fresh through the day.",
  },
  {
    id: "anita",
    name: "Anita Verma",
    role: "Purchase Lead, Hotel Group — Delhi",
    text: "The Cleenvo detergent liquid works perfectly in our commercial laundry. Linen comes out clean, soft and fresh every time. Truly value for money at wholesale rates.",
  },
];

export const MARQUEE_ITEMS = [
  "Wholesale Housekeeping",
  "Office Stationery",
  "Corporate Procurement",
  "Cleenvo — Our Own Brand",
  "Bulk Pricing",
  "Pan-India Delivery",
];
